<template>
  <div class="space-guide__container">
    <div class="fixed__wrapper" v-if="isShow">
      <div class="guide__mask"></div>
      <!-- 步骤一 -->
      <div
        :style="distanceMap.step1"
        v-if="+currentStep === 1"
        class="step__area step__area__1"
      >
        <div class="label__panel">
          <div class="label__wrapper">
            <img class="icon" src="@/images/common/release_icon.png" />
            <span class="text">我要发布现舱</span>
          </div>
        </div>
        <div class="step__panel">
          <div class="img__col">
            <img src="@/images/common/arrow_guide.png" />
          </div>
          <div class="btn__col">
            <div class="row-1">点击此按钮可以发布现舱~</div>
            <div class="row-2">
              <div class="btn__wrapper" @click="nextClick">我知道啦</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { mapState } from "vuex";
// 存储的key值，注意命名唯一性，避免顶级域名下的污染 项目名-工程名-组件/页面名-功能描述
const GUIDE_KEY = "FORALL_CURRENT_CABIN_HALL_SPACE_GUIDE_COMPLETED";
export default {
  data() {
    return {
      hasAuth: false, // 是否权限完整
      currentStep: 1, // 当前步骤
      hasCompleted: false, // 是否完成
      dataReady: false,
      //   定位映射
      distanceMap: {
        step1: {},
      },
    };
  },
  created() {
    console.log('==========space guide组件created',)
  },
  mounted() {
    try {
      //   初始化完成状态
        this.initCompletedStatus();
      // 立即更新完成状态，防止异常引起中断
        this.updateCompletedStatus();
        if (this.hasCompleted) return;
      // 初始化权限状态和距离
      this.initAuthAsync();
    } catch (e) {
      console.error(e);
      this.hasCompleted = true;
    }
  },
  computed: {
    // ...mapState("permission", {
    //   authList: (state) => state.authList,
    // }),
    isShow() {
      // 有权限，未完成
      return this.hasAuth && !this.hasCompleted && this.dataReady;
    },
  },

  methods: {
    // 检查是否有权限 true有 false无,其不再依赖权限状态模块，仅依赖与侧边栏DOM存在
    // 初始化三个步骤的距离
    initAuthAsync() {
      this.$nextTick(() => {
        let guideComponentStep1 = document.querySelector(
          "#spaceGuideComponentStep1"
        );
        if (guideComponentStep1) {
          console.log("==========教程权限完整");
          this.hasAuth = true;
          this.initDistance({
            step1: guideComponentStep1,
          });
          console.log("==========current distance map", this.distanceMap);
          this.dataReady = true;
        } else {
          console.log("==========教程权限不完整");
        }
      });
    },
    //  接受dom map
    initDistance(domMap) {
      // 计算第一步距离
      let rect = this.offset(domMap.step1);
      let cWidth = 174;
      let cHeight = 58;
      this.distanceMap.step1 = {
        top: `${rect.top - (cHeight - rect.height) / 2}px`,
        left: `${rect.left - (cWidth - rect.width) / 2}px`,
      };
    },
    // 接受一个dom元素，返回其距离屏幕顶部和左边的距离，以及元素自身的宽度高度{width,height,top,left}
    offset(dom) {
      if (!dom) return {};
      let rect = dom.getBoundingClientRect();
      console.log("offset", rect);
      return {
        top: rect.top,
        left: rect.left,
        width: rect.width,
        height: rect.height,
      };
    },
    // 检查完成情况
    initCompletedStatus() {
      let key = window.localStorage.getItem(GUIDE_KEY);
      if (+key === 1) {
        // 已经执行过了
        this.hasCompleted = true;
      } else {
        // 没有看过教程
        console.log("==========没有看过教程");
        this.hasCompleted = false;
      }
    },
    // 更新为完成
    updateCompletedStatus() {
      window.localStorage.setItem(GUIDE_KEY, 1);
    },
    nextClick() {
      if (+this.currentStep === 1) {
        this.hasCompleted = true;
        this.currentStep++;
        return;
      }
      this.currentStep++;
    },
  },
};
</script>
<style scoped lang='scss'>
.space-guide__container {
  .fixed__wrapper {
    position: fixed;
    top: 0px;
    left: 0px;
    bottom: 0px;
    width: 100%;
    height: 100%;
    z-index: 99999999;
    .guide__mask {
      position: absolute;
      background-color: black;
      opacity: 0.5;
      width: 100%;
      height: 100%;
    }
    .step__area {
      position: absolute;
      z-index: 1;
      .label__panel {
        // margin-right: 20px;
        height: 58px;
        width: 174px;
        display: inline-block;
        background: #ffffff;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        .label__wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 10px;
          line-height: normal;
          height: 36px;
          background: var(--themeColor);
          // box-shadow: 2px 5px 14px 0px rgba(9, 116, 220, 0.2);
box-shadow:2px 5px 8px 2px rgba(9, 116, 220, 0.1);

          border-radius: 6px;
          .icon {
            width: 24px;
            height: 24px;
            display: block;
            margin-right: 8px;
          }
          .text {
            font-size: 14px;
            font-weight: bold;
            color: #ffffff;
          }
        }
      }
      .step__panel {
        margin-top: 12px;
        margin-left: -38px;
        .img__col {
          width: 34px;
          margin-bottom: 14px;
          img {
            display: block;
            width: 100%;
          }
        }
        .btn__col {
            margin-left: -18px;
          .row-1 {
            font-size: 18px;
            font-weight: bold;
            color: #ffffff;
            margin-bottom: 10px;
          }
          .row-2 {
            display: flex;
            align-items: center;
            // justify-content: center;
            .btn__wrapper {
              cursor: pointer;
              width: 74px;
              height: 32px;
              border: 1px solid #ffffff;
              border-radius: 16px;
              font-size: 14px;
              font-weight: bold;
              color: #ffffff;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }
    .step__area__1 {
      .step__panel {
        .btn__col {
        }
      }
    }
    .step__area__2 {
      .step__panel {
        margin-top: -24px;
        .btn__col {
        }
      }
    }
    .step__area__3 {
      .step__panel {
        position: relative;
        top: -50px;
        left: -40px;
        .btn__col {
          margin-top: -10px;
        }
      }
    }
  }
}
</style>